export default __webpack_public_path__ + "static/media/ic_api.4a3081e8.svg";